// © Microsoft Corporation. All rights reserved.

import IConnectedComponentProps from "./IConnectedComponentProps";

export default IConnectedComponentProps;
export * from "./IConnectedComponentProps";
